import NonWorkingHours from "./legend/NonWorkingHours";
import SleepingHours from "./legend/SleepingHours";
import WorkingHours from "./legend/WorkingHours";
import { useState } from "react";

const CityItem = ({ city, time }) => {
  const [expanded, setExpanded] = useState(false);
  const cityTime = new Date(time).toLocaleTimeString(undefined, {
    timeZone: city.timezone,

    hour: "2-digit",
    hourCycle: "h23",
    minute: "2-digit",
  });
  const cityDate = new Date(time).toLocaleDateString(undefined, {
    timeZone: city.timezone,
    weekday: "short",
    day: "2-digit",
    month: "short",
    hourCycle: "h23",
    year: "2-digit",
  });
  let cityHours = +new Date(time).toLocaleTimeString(undefined, {
    timeZone: city.timezone,
    hourCycle: "h23",
    hour: "2-digit",
  });
  let hoursIcon;
  let workHours;

  if (cityHours < 9 || cityHours === 23) {
    hoursIcon = <SleepingHours />;
    workHours = "red";
  } else if (cityHours === 9 || (cityHours > 18 && cityHours < 23)) {
    hoursIcon = <NonWorkingHours />;
    workHours = "yellow";
  } else {
    hoursIcon = <WorkingHours />;
    workHours = "green";
  }
  return (
    <div
      className={` col-10 offset-lg-0 col-xl-4 col-lg-4 col-md-5 col-sm-5  offset-lg-0 city-item  my-2`}
    >
      <div
        className={` ${
          expanded && "expanded"
        } d-flex row position-relative row-wrapper ${
          !expanded && " ratio-4x3"
        }`}
      >
        <div className={`${!expanded && "d-none"}${city.flag} flag-bg`}></div>
        <div className="city-info-container  col-12 col-xl-12 d-flex flex-row align-items-center ">
          <div className="d-flex flex-column">
            <span className={`  city-info`}>
              <span
                className={`${city.flag} ${expanded && "d-none"}  city-flag`}
              ></span>
              {city.value}
            </span>
          </div>
        </div>
        <div className="container col-12">
          <div className=" row">
            <div className=" col-8  d-flex align-items-center">
              <span className="city-date">{cityDate}</span>
            </div>
            <div className="col-4  d-flex align-items-center justify-content-center">
              <span className={` city-time`}>{cityTime}</span>
            </div>
          </div>
        </div>
        <div
          className={`${
            !expanded && "d-none"
          } col-12 d-flex flex-row align-items-center   justify-content-between`}
        >
          <span className="city-country">{city.country}</span>
          <span className="city-timezone"> {city.timezone}</span>
        </div>
        {/* <div className="icon-container col-1 col-xl-12 d-flex justify-content-center align-items-center g-0 ">
          {hoursIcon}
        </div> */}
        {/* <div className={`${workHours}`}></div> */}
        <button
          className="expand-button"
          onClick={() => {
            setExpanded((prev) => !prev);
          }}
        >
          {!expanded && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              id="expand-alt"
            >
              <path
                fill="black"
                d="M9.79,12.79,4,18.59V17a1,1,0,0,0-2,0v4a1,1,0,0,0,.08.38,1,1,0,0,0,.54.54A1,1,0,0,0,3,22H7a1,1,0,0,0,0-2H5.41l5.8-5.79a1,1,0,0,0-1.42-1.42ZM21.92,2.62a1,1,0,0,0-.54-.54A1,1,0,0,0,21,2H17a1,1,0,0,0,0,2h1.59l-5.8,5.79a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L20,5.41V7a1,1,0,0,0,2,0V3A1,1,0,0,0,21.92,2.62Z"
              ></path>
            </svg>
          )}
          {expanded && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              id="compress-alt"
            >
              <path
                fill="black"
                d="M21.71,2.29a1,1,0,0,0-1.42,0L14.5,8.09V6.5a1,1,0,0,0-2,0v4a1,1,0,0,0,.08.38,1,1,0,0,0,.54.54,1,1,0,0,0,.38.08h4a1,1,0,0,0,0-2H15.91l5.8-5.79A1,1,0,0,0,21.71,2.29ZM10.88,12.58a1,1,0,0,0-.38-.08h-4a1,1,0,0,0,0,2H8.09l-5.8,5.79a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0l5.79-5.8V17.5a1,1,0,0,0,2,0v-4a1,1,0,0,0-.08-.38A1,1,0,0,0,10.88,12.58Z"
              ></path>
            </svg>
          )}
        </button>
      </div>
    </div>
  );
};

export default CityItem;
